/**
 * httpOrigin.ts — shared WS-URL → HTTP-origin helpers.
 *
 * One implementation (App.tsx and the old ApiConnectModal each carried a
 * private copy). `wsUrlToOrigin` returns null for unparseable input so callers
 * can show invalid-URL states; `httpOriginOf` keeps App's historical
 * path-appending behaviour (origin + path, or the bare path on failure) so the
 * existing `httpOriginOf(auth.wsUrl, '/api/projects')` call sites are
 * unchanged.
 */

export function wsUrlToOrigin(wsUrl: string): string | null {
  try {
    const u = new URL(wsUrl);
    const scheme = u.protocol === 'wss:' ? 'https:' : 'http:';
    return `${scheme}//${u.host}`;
  } catch {
    return null;
  }
}

export function httpOriginOf(wsUrl: string, path: string): string {
  const origin = wsUrlToOrigin(wsUrl);
  return origin ? `${origin}${path}` : path;
}

/** The wizard's default backend address — the compose stack's api port. */
export const DEFAULT_WS_URL = 'ws://localhost:8000/ws';

/** Where the health probe goes before any connection is configured. */
export const DEFAULT_HTTP_ORIGIN = 'http://localhost:8000';
